import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { isStaticDocumentRoute } from "./routes";
import "./styles.css";

if (isStaticDocumentRoute(window.location.pathname) && document.getElementById("static-route")) {
  document.documentElement.classList.remove("js");
} else {
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
